import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchClientRelease: DocumentNode = gql`
  query FetchClientRelease($product: String!, $channel: String) {
    fetchClientRelease(product: $product, channel: $channel) {
      mac {
        installer
        installerSize
        minimum
        version
      }
      notes
      win {
        installer
        installerSize
        minimum
        version
      }
    }
  }
`

export default fetchClientRelease
